import DropDown2 from './component'

export default DropDown2
